import React from 'react';
import './style.css';

export default function Rainbow(): React.ReactNode {
  return (
    <div className="vipps-loader">
      <div className="vipps-bow red"></div>
      <div className="vipps-bow orange"></div>
      <div className="vipps-bow yellow"></div>
      <div className="vipps-bow green"></div>
      <div className="vipps-bow blue"></div>
      <div className="vipps-bow purple"></div>
      <div className="vipps-bow center"></div>
      <div className="vipps-bow cover"></div>
    </div>
  );
}
